import { useState } from "react";
import { useLang } from "../../../shared/i18n/useLang";

/**
 * Selector de casa para el dedo: se escribe y aparecen botones grandes. Lo usan
 * Registrar ingreso y Autorizar visita.
 *
 * `casas` es la lista liviana de listaCasas() ([{id, idFilial, propietario}]).
 */
export default function CasaPicker({ casas, value, onChange, error }) {
  const L = useLang();
  const [texto, setTexto] = useState("");
  const elegida = casas.find((c) => c.id === value);

  if (elegida) {
    return (
      <div className="gar-fila" style={{ flexWrap: "nowrap", padding: "8px 10px 8px 14px", borderRadius: 12,
        border: "1px solid var(--gar-acento)", background: "rgba(var(--gar-acento-rgb),0.1)" }}>
        <i className="fa-solid fa-house" style={{ color: "var(--gar-acento)" }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <strong style={{ fontSize: 17 }}>{elegida.idFilial}</strong>
          {elegida.propietario && <div style={{ color: "var(--gar-suave)", fontSize: 13 }}>{elegida.propietario}</div>}
        </div>
        <button type="button" className="gar-btn gar-btn-sec gar-btn-chico" onClick={() => onChange(null)}>
          {L("Cambiar", "Change")}
        </button>
      </div>
    );
  }

  const t = texto.trim().toLowerCase();
  // Primero la casa exacta, después las que empiezan igual (en un condominio
  // grande, "12" tiene que mostrar la casa 12 antes que la 112).
  const rango = (c) => {
    const n = c.idFilial.toLowerCase();
    return n === t ? 0 : n.startsWith(t) ? 1 : 2;
  };
  const lista = casas.filter((c) => !t || c.idFilial.toLowerCase().includes(t)
    || (c.propietario || "").toLowerCase().includes(t))
    .sort((a, b) => rango(a) - rango(b)).slice(0, 8);

  return (
    <>
      <input className={`gar-input ${error ? "error" : ""}`}
        placeholder={L("Escribí la casa o el propietario", "Type the unit or the owner")}
        value={texto} onChange={(e) => setTexto(e.target.value)} autoComplete="off" />
      {error && <div className="gar-error">{error}</div>}
      {t && (
        <div className="gar-stack" style={{ gap: 6, marginTop: 8 }}>
          {lista.length === 0 && (
            <div style={{ color: "var(--gar-suave)", fontSize: 14 }}>
              {L(`No hay casas con "${texto}".`, `No units match "${texto}".`)}
            </div>
          )}
          {lista.map((c) => (
            <button type="button" key={c.id} className="gar-btn gar-btn-sec gar-btn-bloque"
              style={{ justifyContent: "flex-start", fontWeight: 700 }} onClick={() => onChange(c.id)}>
              <span style={{ fontSize: 16, fontWeight: 900 }}>{c.idFilial}</span>
              {c.propietario && <span style={{ color: "var(--gar-suave)", fontWeight: 600 }}>{c.propietario}</span>}
            </button>
          ))}
        </div>
      )}
    </>
  );
}
